import * as constants from './constants';

/* eslint-disable import/prefer-default-export */
export const initializeCMSData = ({
  data,
  isInvalid,
}) => (dispatch) =>
  dispatch({
    type: constants.SET_INITIAL_CMS_DATA_STATE,
    payload: { data, isInvalid },
  });

export const setCMSDataIsInvalid =
  (isInvalid) =>
    (dispatch) =>
      dispatch({
        type: constants.SET_CMS_DATA_IS_INVALID,
        payload: { isInvalid },
      });

export const updateCMSRawData =
  (cmsRawData) => (dispatch) =>
    dispatch({
      type: constants.UPDATE_CMS_RAW_DATA,
      payload: { cmsRawData },
    });

export const resetCMSData = () => (dispatch) =>
  dispatch({
    type: constants.RESET_CMS_DATA,
  });

// from old CollegeProfilePage/actions
export const toggleWebtourOverlay = (isWebtourOverlayVisible) =>
  (dispatch) =>
    dispatch({
      type: constants.TOGGLE_WEBTOUR_OVERLAY,
      payload: { isWebtourOverlayVisible },
    });

export const addMediaLogoFile = (file) =>
  (dispatch) =>
    dispatch({
      type: constants.SET_LOGO_FILE,
      payload: { file },
    });

export const addMediaLogoS3ScannedURI = (s3ScannedURI) =>
  (dispatch) =>
    dispatch({
      type: constants.SET_LOGO_S3_SCANNED_URI,
      payload: { s3ScannedURI },
    });

export const addLogoCroppedImageBlob = (croppedImageBlob) =>
  (dispatch) =>
    dispatch({
      type: constants.SET_CROPPED_LOGO_FILE,
      payload: { croppedImageBlob },
    });

export const resetNonPersistentCollegeProfile = () =>
  (dispatch) => {
    dispatch({
      type: constants.RESET_NON_PERSISTENT_COLLEGE_PROFILE,
    });
    dispatch({
      type: constants.RESET_BASIC_INFO,
    });
  };

export const resetIntroChangesFlag = () =>
  (dispatch) =>
    dispatch({
      type: constants.RESET_INTRO_CHANGES_FLAG,
    });

export const resetMediaChangesFlag = () =>
  (dispatch) =>
    dispatch({
      type: constants.RESET_MEDIA_CHANGES_FLAG,
    });

export const resetLinksAndProfilesChangesFlag = (areNewFlags) =>
  (dispatch) =>
    dispatch({
      type: constants.RESET_LINKS_AND_PROFILES_CHANGES_FLAG,
      payload: { ...areNewFlags },
    });

export const setAreNewLinks = ({ areNewLinks }) =>
  (dispatch) =>
    dispatch({
      type: constants.SET_ARE_NEW_LINKS,
      payload: { areNewLinks },
    });

export const setRequestInformationLink = ({ requestInformationLink, hasRegisteredChanges }) =>
  (dispatch) =>
    dispatch({
      type: constants.SET_REQUEST_INFO_LINK,
      payload: { requestInformationLink, hasRegisteredChanges },
    });

export const setLearnMoreLinks = ({ learnMoreLinks, hasRegisteredChanges }) =>
  (dispatch) =>
    dispatch({
      type: constants.SET_LEARN_MORE_LINKS,
      payload: { learnMoreLinks, hasRegisteredChanges },
    });

export const setApplyOnlineLink = ({ applyOnlineLink, hasRegisteredChanges }) =>
  (dispatch) =>
    dispatch({
      type: constants.SET_APPLY_ONLINE_LINK,
      payload: { applyOnlineLink, hasRegisteredChanges },
    });

export const setNextLinkOrder = (nextOrder) =>
  (dispatch) =>
    dispatch({
      type: constants.SET_NEXT_LINK_ORDER,
      payload: nextOrder,
    });

export const addLearnMoreLink = (url, name, order) =>
  (dispatch) =>
    dispatch({
      type: constants.ADD_LEARN_MORE_LINK,
      payload: {
        active: true,
        category: 'LEARN_MORE',
        info: null,
        order,
        topic: name,
        url,
      },
    });

export const editLearnMoreLink = ({ learnMoreLink, hasRegisteredChanges }) =>
  (dispatch) =>
    dispatch({
      type: constants.EDIT_LEARN_MORE_LINK,
      payload: { learnMoreLink, hasRegisteredChanges },
    });

export const initializeCustomProfiles = ({ customProfiles, hasRegisteredChanges, areNewProfiles }) =>
  (dispatch) =>
    dispatch({
      type: constants.INITIALIZE_CUSTOM_PROFILES,
      payload: { customProfiles, hasRegisteredChanges, areNewProfiles },
    });

export const updateCustomProfiles = (updateProfileData) =>
  (dispatch) =>
    dispatch({
      type: constants.UPDATE_CUSTOM_PROFILES,
      payload: updateProfileData,
    });

export const removeCustomProfile = (profileIndex) =>
  (dispatch) =>
    dispatch({
      type: constants.REMOVE_CUSTOM_PROFILE,
      payload: profileIndex,
    });

export const addCustomProfile = (customProfile) =>
  (dispatch) =>
    dispatch({
      type: constants.ADD_CUSTOM_PROFILE,
      payload: customProfile,
    });

export const removeLearnMoreLink = (linkToRemove) =>
  (dispatch) =>
    dispatch({
      type: constants.REMOVE_LEARN_MORE_LINK,
      payload: { linkToRemove },
    });

export const setAboutUsData = (payload) =>
  (dispatch) =>
    dispatch({
      type: constants.SET_ABOUT_US_DATA,
      payload,
    });

export const deleteAboutUs = () =>
  (dispatch) =>
    dispatch({
      type: constants.DELETE_ABOUT_US,
    });

export const initializeMedia = ({ media, hasRegisteredChanges, isNewMedia, productId }) =>
  (dispatch) =>
    dispatch({
      type: constants.INITIALIZE_MEDIA,
      payload: {
        media,
        hasRegisteredChanges,
        isNewMedia,
        productId,
      },
    });

export const deleteMediaItem = (itemToDeleteIndex) =>
  (dispatch) =>
    dispatch({
      type: constants.DELETE_MEDIA_ITEM,
      payload: { itemToDeleteIndex },
    });

export const savePhotoCaption = ({ caption, photoIndex }) =>
  (dispatch) =>
    dispatch({
      type: constants.SAVE_PHOTO_CAPTION,
      payload: { caption, photoIndex },
    });

export const addMediaPhotoS3ScannedURI = (mediaDisplayUrl, targetIndex) =>
  (dispatch) =>
    dispatch({
      type: constants.SET_PHOTO_S3_SCANNED_URI,
      payload: { mediaDisplayUrl, targetIndex },
    });

export const addPhotoCroppedImageBlob = (croppedImageBlob, targetIndex) =>
  (dispatch) =>
    dispatch({
      type: constants.SET_CROPPED_PHOTO_FILE,
      payload: { croppedImageBlob, targetIndex },
    });

export const setVideo = (video, targetIndex) =>
  (dispatch) =>
    dispatch({
      type: constants.SET_VIDEO,
      payload: { video, targetIndex },
    });

export const addAboutUsPhotoS3ScannedURI = (scannedPhotoUrl) =>
  (dispatch) =>
    dispatch({
      type: constants.SET_ABOUT_US_PHOTO_S3_SCANNED_URI,
      payload: { scannedPhotoUrl },
    });

export const addProfilePhotoFile = (file) =>
  (dispatch) =>
    dispatch({
      type: constants.SET_PROFILE_PHOTO_FILE,
      payload: { file },
    });

export const addProfilePhotoCroppedImageBlob = (croppedImageBlob) =>
  (dispatch) =>
    dispatch({
      type: constants.SET_PROFILE_CROPPED_PHOTO_FILE,
      payload: { croppedImageBlob },
    });

export const addProfilePhotoS3ScannedURI = (profileIndex, scannedPhotoUrl) =>
  (dispatch) =>
    dispatch({
      type: constants.SET_PROFILE_PHOTO_S3_SCANNED_URI,
      payload: { profileIndex, scannedPhotoUrl },
    });
